import styles from '../styles.module.scss';
import skeleton from './styles.module.scss';
import UserIdentityFormContentPersonalIdentityLookUp from '../PersonalIdentityLookUp';
import { UserIdentitiesFormContentProps } from '../props';
import KYCUserIdentityFormContentSteps from '../Steps';

export default function UserIdentitiesFormContentSkeleton({
  isContainerColor,
}: UserIdentitiesFormContentProps) {
  return (
    <div className={styles.container}>
      <KYCUserIdentityFormContentSteps />

      <div
        className={`${styles.container__column} ${styles['container__column--small']} ${styles['container__column--center']}`}
      >
        <div
          className={`${skeleton.lottie} ${
            !isContainerColor
              ? skeleton['lottie--secondary']
              : skeleton['lottie--default']
          }`}
        />
        <div
          className={`${skeleton.title} ${
            !isContainerColor
              ? skeleton['title--secondary']
              : skeleton['title--default']
          }`}
        />
        <div
          className={`${styles.container__column} ${styles['container__column--small']}`}
        >
          <div
            className={`${skeleton.description} ${
              !isContainerColor
                ? skeleton['description--secondary']
                : skeleton['description--default']
            }`}
          />
          <div
            className={`${skeleton.description} ${
              !isContainerColor
                ? skeleton['description--secondary']
                : skeleton['description--default']
            }`}
          />
          <div
            className={`${skeleton.description} ${
              !isContainerColor
                ? skeleton['description--secondary']
                : skeleton['description--default']
            }`}
          />
        </div>
      </div>

      <UserIdentityFormContentPersonalIdentityLookUp
        isSkeleton
        isContainerColor={isContainerColor}
      />
    </div>
  );
}
